export default __webpack_public_path__ + "static/media/Animations_Clock5.3964ec4d.svg";